/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Auto_Replace_ModalInputs */



/**
* | output |
* | --- |
* | "Close Auto Replace modal" |
*
* @param {Close_Auto_Replace_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_auto_replace_modal = /** @type {((inputs?: Close_Auto_Replace_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Auto_Replace_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la fenêtre Remplacement automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatisches Ersetzen-Modal schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la modalità di sostituzione automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть модальное окно автозамены")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar el modal de reemplazo automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭自动替换模态框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動置換モーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो रिप्लेस मॉडल बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar modal de substituição automática")
	return /** @type {LocalizedString} */ ("Close Auto Replace modal")
});